// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.2579 20.5H0.741211L11.9995 1L23.2579 20.5ZM12.9992 12.5316V9H10.9992V12.5316L7.59082 15.372L8.87119 16.9084L11.9992 14.3017L15.1273 16.9084L16.4076 15.372L12.9992 12.5316Z"}}]};

const CoordinateSystemFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'coordinate-system-filled',
    ref,
    icon: element,
  },
));

CoordinateSystemFilledIcon.displayName = 'CoordinateSystemFilledIcon';

export default CoordinateSystemFilledIcon;
